import { createFileRoute } from "@tanstack/react-router";

import { ProfileMessages } from "@/components/profiles";

const ProfileMessagesPage = () => {
  return <ProfileMessages />;
};

export const Route = createFileRoute("/_private/profiles/$id/messages/")({
  component: ProfileMessagesPage,
});
